import http from '@/util/http'

export default {
  getPactFileUrl (data = {}) {
    return http({
      url: `/api/systemAttachment/querySystemAttachmentAddressVo/${data.guid}`,
      method: 'post'
    })
  },
  // 备货审批信息
  stockupCheckInfo (data = {}) {
    return http({
      url: `/api/orderContractStockup/queryBySnaId/${data.snaId}`,
      method: 'post'
    })
  },
  // 备货审批
  stockupCheck (data = {}) {
    return http({
      url: '/api/orderContractStockup/updateProcess',
      method: 'post',
      data
    })
  },
  // 根据id查询备货历史清单
  getStorkHistoryList (data = {}) {
    return http({
      url: `/api/orderContractStockupContent/queryStockupContentListByOcbId/${data.snaId}`,
      method: 'post',
      data
    })
  },
  // 特价审批信息
  specialofferCheck (data = {}) {
    return http({
      url: `/api/customerSpecialPriceApproval/queryByCpaId/${data.snaId}/${data.type}`,
      method: 'post'
    })
  },
  // 特价审批-产品清单
  specialofferProList (data = {}) {
    return http({
      url: `/api/orderContent/queryByObId/${data.obId}`,
      method: 'post'
    })
  },
  // 特价审批提交
  submitSpecialofferCheck (data = {}) {
    return http({
      url: '/api/customerSpecialPriceApproval/updateProcess',
      method: 'post',
      data
    })
  },
  // 报价审批信息
  makeofferCheckInfo (data = {}) {
    return http({
      url: `/api/orderBase/queryBySnaId/${data.snaId}`,
      method: 'post'
    })
  },
  // 报价审批提交
  submitMakeofferCheck (data = {}) {
    return http({
      url: '/api/orderBase/updateProcess',
      method: 'post',
      data
    })
  },
  // 销售合同审批信息
  sellpactCheckInfo (data = {}) {
    return http({
      url: `/api/orderContractBase/queryBySnaId/${data.snaId}`,
      method: 'get'
    })
  },
  // 销售合同审批提交
  submitSellpactCheck (data = {}) {
    return http({
      url: '/api/orderContractBase/updateProcess',
      method: 'post',
      data
    })
  },
  // 销售合同盖章审批信息
  sellpactSealCheckInfo (data = {}) {
    return http({
      url: `/api/orderContractBase/queryOrderContractStamp/${data.snaId}`,
      method: 'post'
    })
  },
  // 销售合同盖章审批提交
  submitSellpactSealCheck (data = {}) {
    return http({
      url: '/api/orderContractBase/updateOrderStamp',
      method: 'post',
      data
    })
  },
  // 销售退货合同盖章审批信息
  sellreturnpactSealCheckInfo (data = {}) {
    return http({
      url: `/api/orderSalereturnContract/queryRetreatStamp/${data.snaId}`,
      method: 'get'
    })
  },
  // 销售退货合同盖章审批提交
  submitreturnSellpactSealCheck (data = {}) {
    return http({
      url: '/api/orderSalereturnContract/updateOrderStamp',
      method: 'post',
      data
    })
  },
  // 释放库存审批信息
  releaseitoryCheckInfo (data = {}) {
    return http({
      url: `/api/orderContractRelease/queryOtherByOcbId/${data.snaId}`,
      method: 'post'
    })
  },
  // 提交释放库存审批
  submitReleaseitoryCheckInfo (data = {}) {
    return http({
      url: '/api/orderContractRelease/updateProcess',
      method: 'post',
      data
    })
  },
  // 发货审批信息
  deliverCheckInfo (data = {}) {
    return http({
      url: `/api/orderContractDeliverGoods/queryBySnaId/${data.snaId}`,
      method: 'get'
    })
  },
  // 发货审批历史清单
  getDeliverHistory (data = {}) {
    return http({
      url: `/api/orderContractDeliverGoodsContent/queryDeliverContentByOcbId/${data.ocbId}`,
      method: 'get'
    })
  },
  // 提交发货审批
  submitDeliverCheckInfo (data = {}) {
    return http({
      url: '/api/orderContractDeliverGoods/updateProcess',
      method: 'post',
      data
    })
  },
  // 坏账审批
  getBaddebtCheckInfo (data = {}) {
    return http({
      url: `/api/financeBadDebt/queryBySnaId/${data.snaId}`,
      method: 'get'
    })
  },
  // 提交坏账审批
  submitBaddebtCheck (data = {}) {
    return http({
      url: '/api/financeBadDebt/updateProcess',
      method: 'post',
      data
    })
  },
  // 销售报缺审批
  getSelllackCheckInfo (data = {}) {
    return http({
      url: `/api/orderContractLack/queryBySnaId/${data.snaId}`,
      method: 'get'
    })
  },
  // 销售报缺审批产品清单
  getSelllackProlistCheckInfo (data = {}) {
    return http({
      url: `/api/orderContractBase/queryContentByOcbId/${data.ocbId}`,
      method: 'get'
    })
  },
  // 提交销售报缺审批
  submitSelllackCheckInfo (data = {}) {
    return http({
      url: '/api/orderContractLack/updateProcess',
      method: 'post',
      data
    })
  },
  // 开票审批
  getMakeinvoiceCheckInfo (data = {}) {
    return http({
      url: `/api/orderContractInvoice/queryBySnaId/${data.snaId}`,
      method: 'get'
    })
  },
  // 提交开票审批
  submitMakeinvoiceCheck (data = {}) {
    return http({
      url: '/api/orderContractInvoice/updateProcess',
      method: 'post',
      data
    })
  },
  // 退货审批
  getSalesreturnCheckInfo (data = {}) {
    return http({
      url: `/api/orderContractSaleReturnGoods/applyForReturnByProcess/${data.snaId}`,
      method: 'get'
    })
  },
  // 提交退货审批
  submitSalesreturnCheck (data = {}) {
    return http({
      url: '/api/orderContractSaleReturnGoods/updateProcess',
      method: 'post',
      data
    })
  },
  // 采购合同审批
  getPoPactCheckInfo (data = {}) {
    return http({
      url: `/api/purchaseContractBase/queryPurchaseBaseByApproval/${data.snaId}`,
      method: 'get'
    })
  },
  // 提交采购合同审批
  submitPoPactCheck (data = {}) {
    return http({
      url: '/api/purchaseContractBase/updatePurchaseBaseApproval',
      method: 'post',
      data
    })
  },
  // 采购合同盖章审批
  getPoPactSealCheckInfo (data = {}) {
    return http({
      url: `/api/purchaseContractBase/queryPurchaseStamp/${data.snaId}`,
      method: 'post'
    })
  },
  // 提交采购合同盖章审批
  submitPoPactSealCheck (data = {}) {
    return http({
      url: '/api/purchaseContractBase/updatePurchaseStamp',
      method: 'post',
      data
    })
  },
  // 采购退货合同盖章审批
  getPoRerutnPactSealCheckInfo (data = {}) {
    return http({
      url: `/api/purchaseRetreatPact/queryRetreatStamp/${data.snaId}`,
      method: 'get'
    })
  },
  // 提交退货采购合同盖章审批
  submitPoRerutnPactSealCheck (data = {}) {
    return http({
      url: '/api/purchaseRetreatPact/updateRetreatPactStamp',
      method: 'post',
      data
    })
  },
  // 采购付款审批
  getPoPayCheckInfo (data = {}) {
    return http({
      url: `/api/purchaseContractOtherPayment/queryApprovalPay/${data.snaId}`,
      method: 'get'
    })
  },
  // 提交采购付款审批
  submitPoPayCheck (data = {}) {
    return http({
      url: '/api/purchaseContractOtherPayment/updateApprovaState',
      method: 'post',
      data
    })
  },
  // 采购报缺审批
  getPoLackCheckInfo (data = {}) {
    return http({
      url: `/api/purchaseContractContent/queryLackApprovalBy/${data.snaId}`,
      method: 'post'
    })
  },
  // 提交采购报缺审批
  submitPoLackCheck (data = {}) {
    return http({
      url: '/api/purchaseContractContent/updateLackApproval',
      method: 'post',
      data
    })
  },
  // 客户提现审批
  getCustomerdepositCheckInfo (data = {}) {
    return http({
      url: `/api/customerWithdrawalApproval/queryByCwaId/${data.snaId}`,
      method: 'get'
    })
  },
  // 提交客户提现审批
  submitCustomerdepositCheck (data = {}) {
    return http({
      url: '/api/customerWithdrawalApproval/updateProcess',
      method: 'post',
      data
    })
  },
  // 客户关系转移审批
  getCustomershiftCheckInfo (data = {}) {
    // /api/customerBaseTransferApproval/queryByCtaId/
    return http({
      url: `/api/customerBaseTransferApproval/queryByCtaId/${data.snaId}`,
      method: 'get'
    })
  },
  // 提交客户关系转移审批
  submitCustomershiftCheck (data = {}) {
    return http({
      url: '/api/customerBaseTransferApproval/transferUpdateProcess',
      method: 'post',
      data
    })
  },
  // 供应商充值审批
  getSupplierrechargeCheckInfo (data = {}) {
    return http({
      url: `/api/supplierRechargeApproval/queryBySwaId/${data.snaId}`,
      method: 'get'
    })
  },
  // 提交供应商充值审批
  submitSupplierrechargeCheck (data = {}) {
    return http({
      url: '/api/supplierRechargeApproval/updateProcess',
      method: 'post',
      data
    })
  },
  // 星级调整审批
  getStarleveladjustCheckInfo (data = {}) {
    return http({
      url: `/api/customerStarApproval/queryByCsaId/${data.snaId}`,
      method: 'post'
    })
  },
  // 提交星级调整审批
  submitStarleveladjustCheck (data = {}) {
    return http({
      url: '/api/customerStarApproval/updateProcess',
      method: 'post',
      data
    })
  },
  // 客户提额审批
  getCustomerliftCheckInfo (data = {}) {
    return http({
      url: `/api/customerAmountApproval/queryByCaaId/${data.snaId}`,
      method: 'get'
    })
  },
  // 提交客户提额审批
  submitCustomerliftCheck (data = {}) {
    return http({
      url: '/api/customerAmountApproval/updateProcess',
      method: 'post',
      data
    })
  },
  // 修改委托人审批
  getUpdatebaliorCheckInfo (data = {}) {
    return http({
      url: `/api/customerBaseAssignorApproval/queryByCaaId/${data.snaId}`,
      method: 'get'
    })
  },
  // 提交修改委托人审批
  submitUpdatebaliorCheck (data = {}) {
    return http({
      url: '/api/customerBaseAssignorApproval/updateProcess',
      method: 'post',
      data
    })
  },
  // 客户余额调整审批
  getCustomerbalanadjustCheckInfo (data = {}) {
    return http({
      url: `/api/customerBalanceApproval/queryByCbaId/${data.snaId}`,
      method: 'post'
    })
  },
  // 提交客户余额调整审批
  submitCustomerbalanadjustCheck (data = {}) {
    return http({
      url: '/api/customerBalanceApproval/updateProcess',
      method: 'post',
      data
    })
  },
  // 供应商账户余额调整审批
  getSupplieraccountadjustCheckInfo (data = {}) {
    return http({
      url: `/api/supplierBalanceApproval/queryBySbaId/${data.snaId}`,
      method: 'get'
    })
  },
  // 提交供应商账户余额调整审批
  submitSupplieraccountadjustCheck (data = {}) {
    return http({
      url: '/api/supplierBalanceApproval/updateProcess',
      method: 'post',
      data
    })
  },
  /**
   * author: wf
   * timer: 2021-01-18 10:37
   * 采购退货审批信息
   */
  getPoreturnCheckInfo(data = {}) {
    return http({
      url: `/api/purchaseContractRetreat/queryRetreatByApproval/${data.snaId}`,
      method: 'post'
    })
  },
  /**
   * author: wf
   * timer: 2021-01-18 10:37
   * 提交退货审批详情
   */
  submitPoreturnCheck(data = {}) {
    return http({
      url: '/api/purchaseContractRetreat/updateRetreatApproval',
      method: 'post',
      data
    })
  },
  /**
   * @author: wf
   * @createdate: 2021-02-22
   * @mark: 采购退货收款审批
   */
  getPorefundsCheckInfo(data = {}) {
    return http({
      url: `/api/purchaseContractRetreat/queryReceiptPage/${data.pcrrId}`,
      method: 'post',
      data
    })
  },
  /**
   * @author: wf
   * @createdate: 2021-02-22
   * @mark: 提交采购退货收款审批
   */
  submitPorefundsCheck(data = {}) {
    return http({
      url: '/api/purchaseContractRetreat/updateReceiptApproval',
      method: 'post',
      data
    })
  },
  /**
   * @author: wf
   * @createdate: 2021-01-21 14:39
   * @mark: 销售结算方案审批详情
   */
  getSalesCheckInfo(data = {}) {
    return http({
      url: `/api/orderContractSaleReturnGoods/costSettlementProcessDetail/${data.snaId}`,
      method: 'post'
    })
  },
  submitReturnSalesCheck(data = {}) {
    return http({
      url: '/api/orderContractSaleReturnGoods/costSettlementProcessCommit',
      method: 'post',
      data
    })
  }
}
